'use client'

import { Button } from '@/components/ui/button'
import * as Sentry from '@sentry/nextjs'
import { useEffect } from 'react'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <html>
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
        definition requires a `statusCode` prop. However, since the App Router
        does not expose status codes for errors, we simply pass 0 to render a
        generic error message. */}
        <div className='flex h-[calc(100vh-200px)] w-screen items-center justify-center overflow-hidden'>
          <div>
            <h1 className='mb-6 text-2xl font-medium'>
              Đã có lỗi xảy ra. Vui lòng thử lại!
            </h1>

            <Button
              onClick={() => {
                window.location.replace(`/`)
              }}
              variant='black'
            >
              Trang chủ
            </Button>

            <Button
              onClick={() => {
                reset()
              }}
              variant='outline-neutral'
            >
              Thử lại
            </Button>
          </div>
        </div>
        {/* <NextError statusCode={0} /> */}
      </body>
    </html>
  )
}
